import React, { useMemo } from 'react'
import { Card, Spinner } from '@shopify/polaris'
import { Bar } from 'react-chartjs-2'
import _ from 'lodash'

const chartSeriesColors = ["#9c6ade", "#59c7c5", "#0090f0", "#5C6AC4"]

const DeemedVatSection = ({ deemedVat, fetchingDeemedVat, t }) => {
	const chartData = useMemo(() => {
		if (_.isEmpty(deemedVat)) return null

		return {
			labels: deemedVat.map((item) => item.month_name),
			datasets: [
				{
					label: t("home.deemedImport"),
					data: deemedVat.map((item) => item.deemed_import),
					backgroundColor: chartSeriesColors[0],
				},
				{
					label: t("home.deemedEur"),
					data: deemedVat.map((item) => item.deemed_eu),
					backgroundColor: chartSeriesColors[1],
				},
			],
		}
	}, [deemedVat, t])

	const chartOptions = useMemo(() => ({
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			legend: {
				display: true,
				position: "bottom",
				align: "center",
			},
		},
		scales: {
			x: {
				position: "bottom",
			},
			y: {
				beginAtZero: true,
				offset: true,
				grace: "10%",
			},
		},
	}), [])

	return (
		<Card sectioned title={t("home.deemedVatTitle")}>
			{fetchingDeemedVat ? (
				<Spinner />
			) : (
				<>
					{!_.isEmpty(deemedVat) ? (
						<div style={{ width: "100%", height: "250px" }}>
							<Bar data={chartData} options={chartOptions} />
						</div>
					) : (
						<p style={{ padding: "2rem" }}>{t("home.noData")}</p>
					)}
				</>
			)}
		</Card>
	)
}

export default DeemedVatSection

